import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Chip } from "@mui/material";
import {
  GridActionsCellItem,
  GridColDef,
  GridRenderCellParams,
} from "@mui/x-data-grid";

import DataTableDefault from "../../../../../components/DataTable";
import { CustomRegime } from "../../../../../types/customRegime";
import { hasClaim } from "../../../../../storage/userClaims";

interface DataTableProps {
  onEditCustomRegime: (id: number | string) => void;
  onDeleteCustomRegime: (id: number | string) => void;
  onViewCustomRegime: (id: number | string) => void;
  data: CustomRegime[];
  [x: string]: any;
}
export default function DataTable({
  onEditCustomRegime,
  onDeleteCustomRegime,
  onViewCustomRegime,
  data,
  center,
  companies,
  userValidation,
  ...props
}: DataTableProps) {
  const renderMenus = (row: any) => {
    return [
      <GridActionsCellItem
        sx={{
          display:
            hasClaim("Custom Regime - Maintenance") ||
            hasClaim("Custom Regime - Visualization")
              ? "block"
              : "none",
        }}
        key={`view-${row.ID_REGIME}`}
        icon={<VisibilityIcon />}
        label="View"
        onClick={() => onViewCustomRegime(row.ID_REGIME)}
        color="inherit"
        data-testid="view-button"
      />,
      <GridActionsCellItem
        sx={{
          display: hasClaim("Custom Regime - Maintenance") ? "block" : "none",
        }}
        key={`edit-${row.ID_REGIME}`}
        icon={<EditIcon />}
        label="Edit"
        className="textPrimary"
        onClick={() => onEditCustomRegime(row.ID_REGIME)}
        color="inherit"
        data-testid="edit-button"
      />,
      <GridActionsCellItem
        sx={{
          display: hasClaim("Custom Regime - Maintenance") ? "block" : "none",
        }}
        key={`delete-${row.ID_REGIME}`}
        icon={<DeleteIcon />}
        label="Delete"
        onClick={() => onDeleteCustomRegime(row.ID_REGIME)}
        color="inherit"
        data-testid="delete-button"
      />,
    ];
  };

  const columns: GridColDef[] = [
    {
      field: "DESCRICAO_REGIME",
      headerName: "Description",
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "ATIVO",
      headerClassName: "super-app-theme--header",
      headerName: "Status",
      flex: 1,
      renderCell: (params: GridRenderCellParams<Date>) =>
        params.value ? (
          <Chip label="Active" color="primary" />
        ) : (
          <Chip label="Inactive" variant="outlined" />
        ),
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      headerClassName: "super-app-theme--header",
      sortable: false,
      width: 160,
      getActions: ({ row }) => renderMenus(row),
    },
  ];
  return (
    <>
      <DataTableDefault
        rowId={data.map((row) => row.ID_REGIME)}
        data-testid="custom-regime-data-table"
        data={data}
        columns={columns}
        {...props}
      />
    </>
  );
}
